/**
 * @flow
 * */

import React from 'react';

const ActivityLogPage = React.lazy(() => import('./views/pages/ActivityLogPage'));

type Route = {
    path: string,
    name: string,
    exact: boolean,
    page: Function,
    subRoutes?: Array<Route>,
}

const ROUTES: Array<Route> = [
  { path: '/activity-log', name: 'Activity Log', exact: true, page: ActivityLogPage }
];

export default ROUTES;
